import React from 'react';
import ReactDOM from 'react-dom';
import { useAttempts } from '../hooks/useAttempts';
import '../styles/attempts.css';

interface ViewAttemptsProps {
  isDark: boolean;
  onClose: () => void;
}

const ViewAttempts: React.FC<ViewAttemptsProps> = ({ isDark, onClose }) => {
  const { attempts, loading, error } = useAttempts();

  React.useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  const getCharacterForRole = (role: string) => {
    if (role === 'user') {
      return '🧙‍♂️'; // Wizard for user
    } else if (role === 'assistant') {
      return '🤖'; // Robot for assistant
    }
    return '❓'; // Default fallback
  };

  const modalContent = (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal-window ${isDark ? 'is-dark' : ''}`} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Recent Attempts</h2>
          <button type="button" onClick={(e) => { e.stopPropagation(); onClose(); }} className="modal-close">×</button>
        </div>
        <div className="modal-content">
          {loading && <div className="modal-message">Loading attempts...</div>}
          {error && <div className="modal-message error">{error}</div>}
          {!loading && !error && !attempts?.length && (
            <div className="modal-message">No recent attempts to display. Be the first to try!</div>
          )}
          {!loading && !error && attempts?.map((attempt) => (
            <div key={attempt.id} className="chat-group">
              {attempt.messages.map((message, index) => (
                <div 
                  key={`${attempt.id}-${index}`} 
                  className={`chat-message ${message.role}`}
                >
                  <div className="chat-avatar">
                    {getCharacterForRole(message.role)}
                  </div>
                  <div className="chat-content">
                    <div className="chat-label">
                      {message.role === 'user' ? 'PLAYER' : 'AGENT'}
                    </div>
                    <div className="chat-bubble">
                      <p>{message.content}</p>
                      <div className="chat-meta">
                        <span className="chat-time">
                          {new Date(message.timestamp).toLocaleTimeString()}
                        </span>
                        {index === 0 && (
                          <span className={`chat-status ${attempt.success ? 'success' : 'failed'}`}>
                            {attempt.success ? '✨ Success' : '💥 Failed'} ({attempt.securityScore}%)
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(
    modalContent,
    document.body
  );
};

export default ViewAttempts; 